import { Component, Input,  Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../api/';
import { EditPlaylistComponent } from '../../index';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
  selector: 'playlist-list-detail',
  templateUrl: './playlist-list-detail.component.html',
  styleUrls: ['./playlist-list-detail.component.css']
})
export class PlaylistListDetailComponent {
  @Input() playlist: any;
  dialogRef: MdDialogRef<EditPlaylistComponent>;
  @Output() refreshPlaylist: EventEmitter<any> = new EventEmitter();

  constructor(private authService: AuthService, public dialog: MdDialog) {
  }

  editPlaylist(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef = this.dialog.open(EditPlaylistComponent, {
      disableClose: false,
      width: '800px'
    });
    this.dialogRef.componentInstance.playlist = this.playlist;
    this.dialogRef.afterClosed().subscribe(result => {
      this.refreshPlaylist.emit({refresh: 1});
      this.dialogRef = null;
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/my-discoveries/playlist-list-detail/playlist-list-detail.component.ts